import React from 'react';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';

import { formatTransactiontDate } from '../../../../helpers/date/date';
import { getStatusColor } from '../../PerformerStatements/IncomeStatement';
import { fetchWithDrawalsStart } from '../../../../store/actions/WithDrawAction';

import './styles/cards.css';
import NothingHere from '../../../../images_new/icon/nothing_here.svg?react';
import {
  updatePayoutInfo,
  initiateTablePayoutStart,
} from "../../../../store/actions/PayoutAction";
import { UserWithdrawalStatus } from '../../../../helpers/constants/payment'
import { statementStatuses } from '../../../../helpers/constants/statementStatuses';

export default function WithdrawalCard() {
  const dispatch = useDispatch();
  const withDrawals = useSelector((state) => state.withDraw.withDrawals.data.history);

  useEffect(() => {
    dispatch(fetchWithDrawalsStart());
  }, []);
  const handleMaxLoad = async (data) => {
    if (
      data.status == UserWithdrawalStatus.APPROVE_BY_ADMIN ||
      data.status == UserWithdrawalStatus.REFERRAL_AUTO_APPROVED
    ) {
      dispatch(updatePayoutInfo({ amount: data.requested_amount }));
      dispatch(initiateTablePayoutStart(data.user_withdrawal_unique_id));
    }
  }

  return (
    <>
      <div className={`cards-container last-card-margin`}>
        {withDrawals && withDrawals.length ? (
          withDrawals.map((withdrawalRequest, index) => (
            <div className={`statement-card ${index % 2 !== 0 ? 'bg-white' : ''}`}>
              <div className='statement-card-body'>
                <div className='w-100 d-flex justify-content-between'>
                  <p className='statement-text-title'>Date & time</p>{' '}
                  <p className='statement-text-data'>
                    {formatTransactiontDate(withdrawalRequest.created)}
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between mt-1'>
                  <p className='statement-text-title'>Invoice</p>{' '}
                  <p className='statement-text-data'>
                    {' '}
                    {withdrawalRequest.user_withdrawal_unique_id}
                  </p>
                </div>
                <div className='w-100 d-flex justify-content-between mt-1'>
                  <p className='statement-text-title'>Payout Amount</p>{' '}
                  <p className='statement-text-data'>
                    {withdrawalRequest.requested_amount_formatted}
                  </p>
                </div>
                <div className={`w-100 d-flex justify-content-between mt-1 `}>
                  <p className='statement-text-title'>Status</p>{' '}
                  <p
                    className={`statement-text-data hidden-xs status-text status-text-${getStatusColor(
                      statementStatuses[withdrawalRequest.status],
                    )}`}
                  >
                    {statementStatuses[withdrawalRequest.status]}{' '}
                  </p>
                </div>
                {
                  withdrawalRequest.status == UserWithdrawalStatus.APPROVE_BY_ADMIN ||
                    withdrawalRequest.status == UserWithdrawalStatus.REFERRAL_AUTO_APPROVED ? <div className={`w-100 d-flex justify-content-between mt-1 `}>
                    <p className='statement-text-title'>Action</p>{' '}
                    <p
                      className={`statement-text-data hidden-xs status-text status-text-${getStatusColor(
                        statementStatuses[withdrawalRequest.status],
                      )}`}
                    >
                      <button className='action_withdrawal_button' onClick={() => handleMaxLoad(withdrawalRequest)} >Withdrawal</button>
                    </p>
                  </div> : <></>
                }
              </div>
            </div>
          ))
        ) : (
          <>
            <div className='d-flex w-100 justify-content-center mt-3'>
              <NothingHere />
            </div>
          </>
        )}
      </div>
    </>
  );
}
